export default __webpack_public_path__ + "static/media/talentsprint.aac727d7.jpg";